import React, { Component } from "react";
import Roundy from "../../services/roundy";
import { tnmformatnumber, invformatnumber } from "../../services/tnminvnumbers";
import { Modal, Checkbox, Table, Button, Icon } from "semantic-ui-react";
import moment from "moment";
import { hashHistory } from "react-router";
import "./WO.css";
import downloadPDF from "../pdf/tnmPDFDownloadmulti";
class RelatedWods extends Component {
  constructor() {
    super();
    // sets false if there are no derivatives in the root wod.
    this.state = {
      print_tnms: [],
      derivlist: true,
      header: ""
    };
  }
  componentDidMount() {
    //    this.querytms();
  }
  componentDidUpdate(prevProps, prevState) {
    console.log("similarwods tnms", prevProps.similarwods);
    if (
      prevProps.similarwods != this.props.similarwods ||
      (this.props.similarwods && !this.state.tnmlist)
    ) {
      console.log("similarwods tnms", this.props.similarwods);
      // this.querytms()
    }
  }
  componentWillUnmount() {
    this.props.closemodal();
  }

  gentable() {
    if (this.props.tnmlist && this.props.tnmlist.length) {
      return (
        <Table id="tmtable" basic="very">
          <Table.Header>
            <Table.Row>
              {this.props.wod.invWorkOrderMain &&
              this.props.wod.workOrderNbr.length === 7 ? (
                <Table.HeaderCell>WO#</Table.HeaderCell>
              ) : (
                <div />
              )}
              <Table.HeaderCell>TM Number</Table.HeaderCell>
              <Table.HeaderCell>Week End Date</Table.HeaderCell>
              <Table.HeaderCell>Labor Charge</Table.HeaderCell>
              <Table.HeaderCell>Material Charge</Table.HeaderCell>
              <Table.HeaderCell>INV Number</Table.HeaderCell>
              <Table.HeaderCell>Print</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{this.gentmlist()}</Table.Body>
        </Table>
      );
    } else {
      return (
        <div>
          <p>No Tnms</p>
        </div>
      );
    }
  }
  gentmlist() {
    console.log("wod tnm list", this.props.tnmlist);
    if (this.props.tnmlist.length) {
      return this.props.tnmlist.map(tnm => {
        var invoice;
        if (
          tnm &&
          tnm.invoicenumber &&
          this.props.invlist &&
          this.props.invlist.length
        ) {
          invoice = this.props.invlist.find(
            inv => inv.number === parseInt(tnm.invoicenumber)
          );
        }

        if (tnm) {
          return (
            <Table.Row positive={tnm.invoicenumber}>
              {this.props.wod.invWorkOrderMain &&
              this.props.wonum.length === 7 ? (
                <Table.Cell
                  selectable
                  onClick={() =>
                    hashHistory.push("/work-orders/" + tnm.workordernumber)
                  }
                >
                  {tnm.workordernumber}
                </Table.Cell>
              ) : (
                <div />
              )}
              <Table.Cell
                selectable
                onClick={() => hashHistory.push("/tmlist/" + tnm.id)}
              >
                {tnmformatnumber(tnm)}
              </Table.Cell>
              <Table.Cell>{moment(tnm.wedate).format("MM/DD/YY")}</Table.Cell>
              <Table.Cell>{"$" + Roundy(tnm.laborfee)}</Table.Cell>
              <Table.Cell>{"$" + Roundy(tnm.materialfee)}</Table.Cell>
              <Table.Cell
                selectable={tnm.invoicenumber}
                onClick={() => {
                  if (invoice) {
                    hashHistory.push("/invlist/" + invoice.id);
                  }
                }}
              >
                {invoice ? invformatnumber(invoice) : "-"}
              </Table.Cell>
              <Table.Cell id="Printbtn">
                <Checkbox
                  onChange={() => this.handleCheck(tnm)}
                  checked={
                    this.state.print_tnms.findIndex(t => t.id === tnm.id) > -1
                      ? true
                      : false
                  }
                />
              </Table.Cell>
            </Table.Row>
          );
        }
      });
    } else {
      return <h3>No Time or Materials for this Workorder/Derivative</h3>;
    }
  }

  handleCheck(tnm) {
    let print_tnms = Array.from(this.state.print_tnms);
    let tnm_index = print_tnms.findIndex(t => t.id === tnm.id);
    if (tnm_index > -1) {
      print_tnms.splice(tnm_index, 1);
    } else {
      print_tnms = print_tnms.concat(tnm);
    }
    this.setState({
      print_tnms: print_tnms.sort(
        (a, b) => parseFloat(a.tmnumber) - parseFloat(b.tmnumber)
      )
    });
  }
  print_tnms(tnms) {
    let print_tnms = tnms.map(tnm => {
      let amount = tnm.laborfee + tnm.materialfee + tnm.travelfee;
      if (tnm.mat_entries.length) {
        tnm.mat_entries = tnm.mat_entries.map(me => {
          return {
            ...me,
            amount: Roundy(me.amount * me.markuppercent)
          };
        });
      }
      amount = amount > tnm.amount ? Roundy(amount) : Roundy(tnm.amount);
      tnm.labor_entries = tnm.labor_entries.filter(le => le.hours > 0);
      let entries = tnm.labor_entries.concat(tnm.mat_entries);
      let prevtmtotal = 0;
      this.props.wod.tmsheets.forEach(tm => {
        if (moment(tm.wedate).isBefore(tnm.wedate)) {
          prevtmtotal += tm.calc_amount;
        }
      });

      return {
        ...tnm,
        tmnumber: tnmformatnumber(tnm),
        wod: this.props.wods.find(
          wod => wod.workOrderNbr === tnm.workordernumber
        ),
        amount,
        prevtmtotal,
        customer: this.props.custinfo,
        entries
      };
    });
    console.log("print_tnms", this.props.custinfo);

    downloadPDF(print_tnms);
  }

  render() {
    return (
      <div className="RelatedWods">
        <Modal
          open={this.props.showModal}
          onClose={() => {
            this.props.closemodal();
            this.setState({ print_tnms: [] });
          }}
          basic={!this.state.derivlist}
          closeOnEscape
          size="large"
          closeOnRootNodeClick
        >
          <div>
            <h2 id="tmheader">{this.props.wonum + " Time and Materials"}</h2>
          </div>
          <Button
            icon
            primary
            id="tmprintbtn"
            onClick={() => this.print_tnms(this.state.print_tnms)}
            disabled={!this.state.print_tnms.length}
          >
            <Icon name="print" />
          </Button>

          <Modal.Content>{this.gentable()}</Modal.Content>
        </Modal>
      </div>
    );
  }
}

export default RelatedWods;



// WEBPACK FOOTER //
// ./src/components/wod/tnmlistmodal.jsx